const ZimssaConstant = {
  SUBSCRIPTION_TYPE: [
    '지인 소개',
    '일하다 만난 기사',
    '온라인 광고',
    '오프라인 광고',
    '기타',
  ],
  EMAIL_LIST: [
    { name: '직접입력', value: '직접입력' },
    { name: 'naver.com', value: 'naver.com' },
    { name: 'hanmail.net', value: 'hanmail.net' },
    { name: 'daum.net', value: 'daum.net' },
    { name: 'gmail.com', value: 'gmail.com' },
    { name: 'nate.com', value: 'nate.com' },
    { name: 'hotmail.com', value: 'hotmail.com' },
    { name: 'korea.com', value: 'korea.com' },
    { name: 'empal.com', value: 'empal.com' },
    { name: 'dreamwiz.com', value: 'dreamwiz.com' },
    { name: 'yahoo.com', value: 'yahoo.com' },
  ],
  CAR_INFO: {
    COLOR: [
      { color: 'gray_opacity_50', value: '흰색' },
      { color: 'gray_opacity_300', value: '회색' },
      { color: 'gray_opacity_600', value: '진한회색' },
      { color: 'gray_opacity_900', value: '검정색' },
      { color: 'blue_900', value: '청색' },
      { color: 'red_900', value: '빨간색' },
      { color: 'yellow_900', value: '노란색' },
      { color: 'green_800', value: '녹색' },
    ],
    COLOR_TEXT: [
      { name: '흰색', value: '흰색' },
      { name: '청색', value: '청색' },
      { name: '기타', value: '기타' },
    ],
    SIZE_FAMILY: [
      { name: '1톤', value: '1톤' },
      { name: '1.2톤', value: '1.2톤' },
      { name: '2.5톤', value: '2.5톤' },
      { name: '3.5톤', value: '3.5톤' },
      { name: '5톤', value: '5톤' },
    ],
    SIZE_SMALL: [
      { name: '1톤', value: '1톤' },
      { name: '1톤 증축(1.2톤~1.5톤)', value: '1톤 증축(1.2톤~1.5톤)' },
      { name: '2.5톤', value: '2.5톤' },
      { name: '3.5톤', value: '3.5톤' },
      { name: '5톤', value: '5톤' },
    ],
    TYPE: [
      { name: '일반카고', value: '일반카고' },
      { name: '고정식 호루', value: '고정식 호루' },
      { name: '접이식 호루', value: '접이식 호루' },
      { name: '윙바디', value: '윙바디' },
      { name: '탑차', value: '탑차' },
      { name: '기타', value: '기타' },
    ],
    ETC: ['리프트', '무진동'],
    LOCATION: [
      { name: '서울', value: '서울' },
      { name: '인천', value: '인천' },
      { name: '대전', value: '대전' },
      { name: '부산', value: '부산' },
      { name: '대구', value: '대구' },
      { name: '광주', value: '광주' },
      { name: '울산', value: '울산' },
      { name: '제주', value: '제주' },
      { name: '세종', value: '세종' },
      { name: '경기', value: '경기' },
      { name: '강원', value: '강원' },
      { name: '충북', value: '충북' },
      { name: '충남', value: '충남' },
      { name: '전북', value: '전북' },
      { name: '전남', value: '전남' },
      { name: '경북', value: '경북' },
      { name: '경남', value: '경남' },
    ],
    NUMBER_KR: [
      { name: '아', value: '아' },
      { name: '바', value: '바' },
      { name: '사', value: '사' },
      { name: '자', value: '자' },
    ],
  },
  IS_FRANCHISEE: [
    { name: '가맹', value: true },
    { name: '미가맹', value: false },
  ],
  IS_HAVE: [
    { name: '있음', value: 1 },
    { name: '없음', value: 0 },
  ],
  AUTH_EXPIRE_TIME: 180,
  AUTH_RESEND_TIME: 175,
  API_RESULT: {
    SUCCESS: 'success',
    FAILURE: 'fail',
    ERROR: 'error',
  },
  BUSINESS_REGISTRATION_OWNER: [
    { name: '본인', value: '본인' },
    { name: '가족', value: '가족' },
  ],
  TAX_CLASSIFICATION: [
    { name: '일반과세자', value: '일반' },
    { name: '간이과세자', value: '간이' },
  ],
  IMG_DIR: {
    PARTNER: {
      DOC: 'partner/{{partnerIdx}}/doc/', //소형 추가서류, 가정 이사화물 배상책임보험, 주선면허 사업자, 가족관계증명서 등등 서류
    },
    PARTNER_USER: {
      PROFILE: 'partner/{{partnerIdx}}/user/',
    },
    SERVICE: {
      FAMILYMOVE: 'partner/{{partnerIdx}}/service/familymove/',
      SMALLMOVE: 'partner/{{partnerIdx}}/service/smallmove/',
      MOVECLEANING: 'partner/{{partnerIdx}}/service/movecleaning/',
      SMALLMOVE_CAR: 'partner/{{partnerIdx}}/service/smallmove/car/',
      FAMILYMOVE_CAR: 'partner/{{partnerIdx}}/service/familymove/car/',
    },
  },
};

export default ZimssaConstant;

export const SERVICE_INFO: { [key: string]: any } = {
  small_move: {
    name: '소형이사',
    description: '거주자 2인 이하 / 1톤 2대 이하 일 경우 ',
  },
  family_move: {
    name: '가정이사',
    description: '거주자 3인 이상 / 1톤 3대 혹은 5톤 이상 일 경우 ',
  },
  move_cleaning: {
    name: '청소',
    description: '이사청소/입주청소/거주청소',
  },
};

export const MEGA_BYTE_10 = 1024 * 1024 * 10;

export const GUIDE_TYPE = {
  PROFILE: 'PROFILE',
  SERVICE: 'SERVICE',
  FIELD_PHOTO: 'FIELD_PHOTO',
} as const;

export const UPLOAD_TYPE = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE',
} as const;

export const SERVICE_TYPE = {
  FAMILY_MOVE: 'FAMILY_MOVE',
  SMALL_MOVE: 'SMALL_MOVE',
  MOVE_CLEANING: 'MOVE_CLEANING',
} as const;

export const SERVICE_OFFER_STATUS = {
  AVAILABLE: 'AVAILABLE',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  NEGOTIABLE: 'NEGOTIABLE',
} as const;
